export const style = {
  TableRow: {
    sx: {
      height: 500,
      width: 600,
    },
  },
  TableCol: {
    sx: {
      border: 0,
      textAlign: 'center',
    },
  },
  typography: {
    fontWeight: 700,
    sx: {
      color: 'primary.dark',
    },
  },
  box: {
    sx: {
      '& svg': {
        width: 75,
        height: 65,
      },
    },
  },
} as const;
